import React from 'react';

import { SpotlightPulse } from '@atlaskit/onboarding';

import { fg } from '@confluence/feature-gating';

import { useDiscoverabilityPulse } from './useDiscoverabilityPulse';
import { useDiscoverabilityPulsePostOffice } from './usePostOfficeDiscoverabilityPulse';


type DiscoverabilityPulseProps = {
	children: JSX.Element;
	entryPointId: string;
	isCircle?: boolean;
};

export const DiscoverabilityPulse = ({
	children,
	entryPointId,
	isCircle,
}: DiscoverabilityPulseProps) => {
	const { isPulseActive: isPulseActiveEP } = useDiscoverabilityPulse(entryPointId);
	const { isPulseActive: isPulseActivePostOffice } = useDiscoverabilityPulsePostOffice(entryPointId);

	const isPulseActive = fg('confluence_loom_x-sell_ep_po_migration')
		? isPulseActivePostOffice
		: isPulseActiveEP;


	if (!isPulseActive) {
		return children;
	}

	return (
		<SpotlightPulse radius={isCircle ? 24 : 3} testId="loom-cross-sell-discoverability-pulse">
			{children}
		</SpotlightPulse>
	);
};
